import { Box, FieldSet, Heading, Legend, Paragraph } from '@zillow/constellation-10';

import { TourAvailabilityCards } from '@zg-rentals/touring';

import {
  wizardFormSectionContainerStyles,
  wizardHeadingStyles,
  wizardParagraphStyles,
} from '../../../../../styles/wizard';

import type { AvailabilityDate, TimeZoneIds } from '@zg-rentals/touring';
import type { TourDuration } from '@zg-rentals/ts-z-calendar-client';

type TourSchedulingAvailabilityBodyProps = {
  availabilityDates: Array<AvailabilityDate>;
  onAvailabilityDatesChange: (availabilityDates: Array<AvailabilityDate>) => void;
  timeZone: TimeZoneIds;
  tourDuration?: TourDuration;
};

const TourSchedulingAvailabilityBody = ({
  availabilityDates,
  onAvailabilityDatesChange,
  timeZone,
  tourDuration,
}: TourSchedulingAvailabilityBodyProps) => {
  return (
    <div data-testid="TourSchedulingAvailabilityBody">
      <Box css={wizardFormSectionContainerStyles.raw()}>
        <Heading
          level={1}
          textStyle="heading-sm"
          css={wizardHeadingStyles}
          data-testid="TourSchedulingAvailabilityBody-Heading"
        >
          When are you free for tours?
        </Heading>
        <Paragraph css={wizardParagraphStyles} data-testid="TourSchedulingAvailabilityBody-Description">
          Add a few dates and times up to three weeks from today. Then you can start booking tours as soon as your
          listing’s live. We recommend you add more after your listing is published.
        </Paragraph>

        <FieldSet
          legend={<Legend size="lg">Tour availability</Legend>}
          required={true}
          css={{ marginBottom: 'default' }}
        >
          <TourAvailabilityCards
            availabilityDates={availabilityDates}
            onAvailabilityDatesChange={onAvailabilityDatesChange}
            timeZone={timeZone}
            tourDuration={tourDuration}
          />
        </FieldSet>
      </Box>
    </div>
  );
};

export default TourSchedulingAvailabilityBody;
